import React from 'react';
import { Clock, FileEdit, Map, Layout } from 'lucide-react';
export function Benefits() {
  return <section className="py-24 bg-white" data-id="element-1">
      <div className="container mx-auto px-4" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-black text-gray-900 mb-6 leading-tight" data-id="element-4">
            Por qué este pack te cambia el año
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 max-w-7xl mx-auto" data-id="element-5">
          <div className="flex flex-col items-center text-center group" data-id="element-6">
            <div className="bg-blue-600 p-5 rounded-2xl shadow-xl mb-6 transform transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3" data-id="element-7">
              <Clock className="w-10 h-10 text-white" data-id="element-8" />
            </div>
            <h3 className="text-2xl font-black text-gray-900 mb-4" data-id="element-9">
              Ahorro de tiempo
            </h3>
            <p className="text-base text-gray-600 leading-relaxed" data-id="element-10">
              No pierdas horas planificando. Tenés clases listas para aplicar y
              secuencias armadas con lógica pedagógica.
            </p>
          </div>

          <div className="flex flex-col items-center text-center group" data-id="element-11">
            <div className="bg-amber-500 p-5 rounded-2xl shadow-xl mb-6 transform transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3" data-id="element-12">
              <FileEdit className="w-10 h-10 text-white" data-id="element-13" />
            </div>
            <h3 className="text-2xl font-black text-gray-900 mb-4" data-id="element-14">
              100% editable
            </h3>
            <p className="text-base text-gray-600 leading-relaxed" data-id="element-15">
              Archivos en Word / PowerPoint / PDF (según tu entrega) para
              adaptar a tu grupo, escuela y estilo.
            </p>
          </div>

          <div className="flex flex-col items-center text-center group" data-id="element-16">
            <div className="bg-red-600 p-5 rounded-2xl shadow-xl mb-6 transform transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3" data-id="element-17">
              <Map className="w-10 h-10 text-white" data-id="element-18" />
            </div>
            <h3 className="text-2xl font-black text-gray-900 mb-4" data-id="element-19">
              Alineado a lo curricular
            </h3>
            <p className="text-base text-gray-600 leading-relaxed" data-id="element-20">
              Contenidos pensados para trabajar con objetivos reales de aula y
              progresión por niveles.
            </p>
          </div>

          <div className="flex flex-col items-center text-center group" data-id="element-21">
            <div className="bg-purple-600 p-5 rounded-2xl shadow-xl mb-6 transform transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3" data-id="element-22">
              <Layout className="w-10 h-10 text-white" data-id="element-23" />
            </div>
            <h3 className="text-2xl font-black text-gray-900 mb-4" data-id="element-24">
              Versatilidad total
            </h3>
            <p className="text-base text-gray-600 leading-relaxed" data-id="element-25">
              Ideal para escuelas, talleres, clases particulares, centros
              culturales o proyectos institucionales.
            </p>
          </div>
        </div>
      </div>
    </section>;
}